export function debounce<T extends (...args: any[]) => any>(
    callback: T,
    delay: number
): (...args: Parameters<T>) => Promise<ReturnType<T>> {
    let timer: ReturnType<typeof setTimeout>;

    return (...args: Parameters<T>): Promise<ReturnType<T>> => {
        return new Promise((resolve, reject) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                try {
                    const output = callback(...args);
                    resolve(output);
                } catch (err) {
                    reject(err);
                }
            }, delay);
        });
    };
}

export const isValidSuggestionKey = (key: string): boolean => {
    if (/^[a-zA-Z]$/.test(key)) {
        return true;
    }

    if (key === '"' || key === "'" || key === "`") {
        return true;
    }

    const specialKeys = ["ArrowRight", ":", ",", "Backspace", " ", "ArrowDown", "Enter", "Tab", "Escape"];
    if (specialKeys.includes(key)) {
        return true;
    }

    return false;
};

export const createGhostEl = () => {
    // loading img
    const img = document.createElement("img");
    img.src = "/images/autocomplete-loading.svg";
    img.alt = "Kai";
    img.style.width = "15px";
    img.style.height = "15px";
    img.style.marginRight = "6px";
    img.style.marginLeft = "6px";
    img.style.verticalAlign = "middle";
    img.className = "pulsing-image";

    // ghost text container
    const container = document.createElement("span");
    container.id = "ghost-text-container";
    container.style.width = "fit-content";

    // ghost text suggestion text
    const span = document.createElement("span");
    span.className = "ghost-text";
    span.id = "ghost-text";
    span.style.userSelect = "none";

    return { span, container, img };
};
